import { Button } from '@usealloy/component-library';
import { darken } from 'polished';
import styled from 'styled-components';

import { getColorFromVariable } from 'flow/editor/components/helpers';


interface NodeDropdownMenuTriggerProps {
  backgroundColor: string;
}

const NodeDropdownMenuTrigger = styled(Button)<NodeDropdownMenuTriggerProps>`
  &&& {
    width: 20px;
    height: 20px;
    mix-blend-mode: normal; // Reset the mix-blend-mode here because these can be on dark backgrounds and we can't multiply white text
  }
  &:hover {
    &&& {
      background-color: ${props => darken(0.15, getColorFromVariable(props.backgroundColor))};
    }
  }
`;

export default NodeDropdownMenuTrigger;


/**

  Due to some quirk when using styled-components and our DropdownMenu,
  defining a custom component to be used a dropdown menu trigger is not
  possible currently.

  Ideally, we'd define the custom trigger like so:

function NodeDropdownTrigger({
  backgroundColor,
}: NodeDropdownMenuTriggerProps, ref: React.Ref<HTMLDivElement>) {
  return (
      <StyledButton
      ref={ref}
        backgroundColor={backgroundColor}
        icon={IconName.More}
        size={ButtonSize.xsmall}
        variant={ButtonVariant.tertiary}
        style={{ borderRadius: 1 }}
      />
  );
}

export default React.forwardRef(NodeDropdownTrigger);
*/
